/**
 * Medication mixin
 */



import {Observable} from 'rxjs/Rx'
import MedicationsApi from '../../api/Tracking/Medication'

export default {
  data() {
    return {
      medicationSearchValue: "",
      medicationInputClass: "mediSearchInput",
      medicationSearching: false,
      medicationDataSource: [],
      medicationDataSourceConfig: {
        text: 'treatment_name',
        value: 'treatment_id'
      },
    }
  },
  mounted() {
    let self = this;
    const medicationInputElement = $('.' + self.medicationInputClass);
    Observable
      .fromEvent(medicationInputElement, 'input').map(x => x.currentTarget.value)
      .debounceTime(250)
      .subscribe(function (eventText) {
        self.handleSearch(eventText);
      });
  },
  methods: {
    handleSearch(searchText) {
      let self = this;
      self.medicationSearching = true;
      MedicationsApi.getTreatments(searchText)
        .then(function (response) {
          self.medicationDataSource = [];
          for (var i = 0; i < response.data.length; i++) {
            let medication = {
              'treatment_id': response.data[i].ID,
              'treatment_name': response.data[i].title,
              'rightIcon': 'add'
            };
            self.medicationDataSource.push(medication)
          }
          self.medicationSearching = false
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/MedicationSearchMixin/index.js